import { useEffect, useRef, useState } from 'react'

type UseCountdownTimer = {
  timeLeft: number
  isActive: boolean
  setTargetTime: (utcTime: string) => void
}

export const useCountdown = (initialUtcTime: string): UseCountdownTimer => {
  const [timeLeft, setTimeLeft] = useState(0)
  const [isActive, setIsActive] = useState(false)
  const [targetTime, setTargetTimeState] = useState(initialUtcTime)

  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const getTimeLeft = (time: string) => {
    const target = new Date(time).getTime()
    const now = Date.now()
    return Math.max(0, target - now)
  }

  const updateState = (msLeft: number) => {
    setTimeLeft(msLeft)
    setIsActive(msLeft === 0)
  }

  const tick = () => {
    const remaining = getTimeLeft(targetTime)
    updateState(remaining)

    if (remaining === 0) {
      stopCountdown()
    }
  }

  const startCountdown = () => {
    tick()

    if (getTimeLeft(targetTime) > 0) {
      intervalRef.current = setInterval(tick, 1000)
    }
  }

  const stopCountdown = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const setTargetTime = (utcTime: string) => {
    setTargetTimeState(utcTime)
    setIsActive(false)
  }

  useEffect(() => {
    stopCountdown()
    startCountdown()

    return stopCountdown
  }, [targetTime])

  return {
    timeLeft,
    isActive,
    setTargetTime,
  }
}
